// extracted by mini-css-extract-plugin
var _1 = "RentalPortalOverviewViewingRow-moduleapplicant__xG6iz OverviewViewingText-moduleOverviewViewingText__wM5YZ";
export { _1 as "applicant" }
